import React, { useEffect, useState } from 'react';
import './LevelProgress.css';

export default function LevelProgress({ oldLevel = 3, newLevel = 3 }) {
  const [currentDisplayLevel, setCurrentDisplayLevel] = useState(oldLevel);
  const [status, setStatus] = useState('initial'); // 'initial', 'up', 'down', 'stable'

  useEffect(() => {
    // 600ms buffer so the student can process their starting state
    const timer = setTimeout(() => {
      setCurrentDisplayLevel(newLevel);
      
      if (newLevel > oldLevel) {
        setStatus('up');
      } else if (newLevel < oldLevel) {
        setStatus('down');
      } else {
        setStatus('stable');
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [oldLevel, newLevel]);

  // Determine helper text and icons based on status state
  const getStatusDetails = () => {
    switch (status) {
      case 'up':
        return { text: '🎉 LEVEL UP!', class: 'text-up' };
      case 'down':
        return { text: '⚠️ LEVEL DROPPED', class: 'text-down' };
      case 'stable':
        return { text: '✨ LEVEL MAINTAINED', class: 'text-stable' };
      default:
        return { text: 'Calculating...', class: 'text-muted' };
    }
  };

  const statusDetails = getStatusDetails();

  return (
    <div className="level-progress-container">
      <span className="level-label">TOPIC MASTERY</span>
      
      <div className={`level-badge-wrapper status-${status}`}>
        <div className="level-circle">
          <span className="level-number">{currentDisplayLevel}</span>
        </div>
        
        {/* Celebration burst rings for leveling up */}
        {status === 'up' && (
          <>
            <div className="pulse-ring ring-up-1"></div>
            <div className="pulse-ring ring-up-2"></div>
          </>
        )}
      </div>

      <div className={`level-status-text ${status !== 'initial' ? 'show-text' : ''} ${statusDetails.class}`}>
        {statusDetails.text}
      </div>
    </div>
  );
}